import { render, staticRenderFns } from "./kommentti-card.vue?vue&type=template&id=eb2bbf84&scoped=true&"
import script from "./kommentti-card.vue?vue&type=script&lang=ts&"
export * from "./kommentti-card.vue?vue&type=script&lang=ts&"
import style0 from "./kommentti-card.vue?vue&type=style&index=0&id=eb2bbf84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2bbf84",
  null
  
)

export default component.exports